import React from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import { InnerFactoryAuthBoxContainer } from './AuthList.css';

const InnerFactoryAuthBox = ({ childsAuth, selectAuth, setSelectAuth }) => {
  const handleClick = (auth) => {
    setSelectAuth(auth);
  };
  return (
    <InnerFactoryAuthBoxContainer>
      {childsAuth.map((auth) => {
        return (
          <div
            className={classNames('content', selectAuth && selectAuth.authIdx === auth.authIdx && 'on')}
            onClick={() => {
              handleClick(auth);
            }}
          >
            ● {auth.authNm} - {auth.memo}
          </div>
        );
      })}
    </InnerFactoryAuthBoxContainer>
  );
};

export default InnerFactoryAuthBox;
